export default __webpack_public_path__ + "static/media/MATH_ABSTRACT.47bc68c7.svg";